import React from 'react';

import classNames from 'classnames/bind';
import style from './Banner.scss';
const ctx = classNames.bind(style);

import ReadMoreLink from '../ReadMoreLink';

const Banner = props => (
  <div
    className={ctx('banner')}
    style={{
      ...props.style,
      backgroundImage: `url(${props.bannerBackground})`,
    }}
  >
    <img
      src={'images/gals_logo.svg'}
      className={ctx('gals-logo')}
      width="235px"
    />
    <div className={ctx('text')}>{props.text}</div>
    <ReadMoreLink
      title={props.linkTitle}
      link={props.link}
      style={{ backgroundColor: '#ECB84C' }}
    />
  </div>
);

export default Banner;
